const capabilities = {
    app: ['loader', 'paginator', 'filter', 'sorter', 'exporter', 'error-logger'],
    entity: ['safe-deleter', 'workflow']
};

export default capabilities;
